import { getQueue, removeFromQueue, incrementVersuche, OfflineQueueItem } from './diktat-offline-db';
import { diktatStart, diktatAudio, diktatVerarbeiten } from './diktat-api';
import { toast } from './toast';

const MAX_VERSUCHE = 5;

// Exponential backoff in Minuten: 1, 5, 15, 60, 360
const BACKOFF_MINUTEN = [1, 5, 15, 60, 360];

let syncing = false;

function backoffAbgelaufen(item: OfflineQueueItem): boolean {
  if (!item.letzter_versuch) return true;
  const minSeit = (Date.now() - new Date(item.letzter_versuch).getTime()) / 60_000;
  const wartezeit = BACKOFF_MINUTEN[Math.min(item.sync_versuche - 1, BACKOFF_MINUTEN.length - 1)] ?? 360;
  return minSeit >= wartezeit;
}

export async function syncQueue(): Promise<void> {
  if (syncing || !navigator.onLine) return;
  syncing = true;

  try {
    const queue = await getQueue();
    if (queue.length === 0) return;

    let erfolge = 0;
    for (const item of queue) {
      if (item.sync_versuche >= MAX_VERSUCHE) continue;
      if (!backoffAbgelaufen(item)) continue;

      try {
        const { id } = await diktatStart(item.eingang, item.quick_mic_modul ?? undefined, item.schueler_id ?? null);

        // Blob-Typ bestimmen
        const mime = item.audioBlob.type || 'audio/webm';
        const ext  = mime.includes('ogg') ? 'ogg' : mime.includes('mp4') ? 'mp4' : mime.includes('wav') ? 'wav' : 'webm';

        await diktatAudio(id, item.audioBlob, ext);
        await diktatVerarbeiten(id);

        await removeFromQueue(item.id!);
        erfolge++;
      } catch {
        await incrementVersuche(item.id!);
      }
    }

    if (erfolge > 0) {
      toast(`${erfolge} Diktat${erfolge !== 1 ? 'e' : ''} synchronisiert`);
    }
  } finally {
    syncing = false;
  }
}

let listenerRegistered = false;

export function registerSyncListener(): void {
  if (listenerRegistered) return;
  listenerRegistered = true;

  window.addEventListener('online', () => {
    setTimeout(syncQueue, 1_000); // kurz warten bis Verbindung stabil
  });

  // Initiale Sync-Prüfung beim Start
  if (navigator.onLine) {
    setTimeout(syncQueue, 3_000);
  }
}
